import { LitElement, html } from "lit-element";
import { store } from "@stofloos/stores/store";
import { exportXLS } from "@stofloos/actions/file";
import { initRequest } from "@stofloos/actions/requests";

export class ButtonExportXLS extends LitElement {
	static get properties() {
		return {
			label: { type: String },
			endpoint: { type: String },
			id: { type: String },
			data: { type: Object },
			disabled: { type: Boolean }
		};
	}

	constructor() {
		super();
	}

	render() {
		return html`
			<button-contained label="${this.label}" @click="${() => this.createObject()}"></button-contained>
		`;
	}

	createObject() {
		store.dispatch(exportXLS(this.requestId, this.data));
	}

	firstUpdated(_changedProperties) {
		super.firstUpdated(_changedProperties);

		this.requestId = this.endpoint;
		store.dispatch(initRequest(this.requestId, this.endpoint));
	}
}

customElements.define("button-export-xls", ButtonExportXLS);
